import type { InlineNode, PlateSegment } from '../types'

export const isObject = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object'

export const isValidUrl = (value: string) => {
  try {
    return Boolean(new URL(value))
  } catch (_) {
    return false
  }
}

export const groupBy = <T>(
  items: T[],
  getKey: (item: T, index: number) => number | string
) => {
  const groups = new Map<number | string, T[]>()

  items.forEach((item, index) => {
    const key = getKey(item, index)

    groups.set(key, [...(groups.get(key) || []), item])
  })

  return Array.from(groups.values())
}

export const inlineItem = (
  segment: PlateSegment,
  type: string
): InlineNode | undefined => segment.inline?.find((item) => item.type === type)
